import React from 'react';

var More = function More(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

More.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { More as icon };
export default iconHandler(More);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/More.js
// module id = 614
// module chunks = 0